import { useMediaQuery } from '@mui/material';
import { BlockWrapper, defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import React from 'react';
import { Profile } from '../components';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';
import Button from '../button/block';
import style from './block.module.scss';
import { ReactComponent as UserIcon } from '../assets/icon-user.svg';
import clsx from 'clsx';

const Inspector = React.lazy(() => import('./Inspector'));

const Block = ({
    menu,
    secondMenu,
    isUserConnected,
    user,
    buttonText,
    myAccountLink,
    sponsorPageLink,
    rulesGameLink,
    customSettings,
    isRegistrationPage = false,
    hideMobileLogo = false,
    isLandingPage = false,
}) => {
    useInspectorControl(Inspector);
    const isLaptop = useMediaQuery(`(max-width: ${style.headerBreakpoint})`);
    const isMobile = useMediaQuery(`(max-width: ${style.mobileBreakpoint})`);

    const handleOpenPopinSignupEvent = () => {
        if (isUserConnected) return;
        // Fire the event "openPopinSignup"
        document.dispatchEvent(new CustomEvent('openPopinSignup', { detail: { openModal: true } }));
    };

    const Account = () =>
        !isRegistrationPage &&
        (isUserConnected ? (
            <Profile
                classNames={!isLaptop ? style.profile : undefined}
                user={user}
                myAccountLink={myAccountLink}
                sponsorPageLink={sponsorPageLink}
                rulesGameLink={rulesGameLink}
            />
        ) : (
            <div className={style.unlogged}>
                <Button
                    classNames={clsx(style.headerButton, 'button-myhand-small')}
                    text={buttonText}
                    aspect="contained"
                    backgroundContained={style.green}
                    colorContained={style.blue}
                    position="right"
                    onClick={handleOpenPopinSignupEvent}
                    Wrapper="button"
                    inspector={false}
                />
                {!isMobile && (
                    <a href="/se-connecter" className={style.login}>
                        <UserIcon />
                    </a>
                )}
            </div>
        ));

    return (
        <BlockWrapper.Div>
            {!isLaptop ? (
                <HeaderDesktop
                    menu={menu}
                    secondMenu={secondMenu}
                    accountBlock={<Account />}
                    isLandingPage={isLandingPage}
                    isUserConnected={isUserConnected}
                />
            ) : (
                <HeaderMobile
                    menu={menu}
                    secondMenu={secondMenu}
                    customSettings={customSettings}
                    accountBlock={<Account />}
                    isRegistrationPage={isRegistrationPage}
                    hideMobileLogo={hideMobileLogo}
                    isLandingPage={isLandingPage}
                    isUserConnected={isUserConnected}
                />
            )}
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        buttonText: smartProps.string.withDefault('JE M’INSCRIS'),
    },
    setup: {
        title: 'Header',
    },
});
